 import React from 'react'
 function about (props){
     return (
         <div id="about">
            <div className="about-image">
                <img src={props.image}/>
            </div>
            <div className="about-text">
                <h2>{props.title}</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias, porro reprehenderit ipsam ad hic consequatur. Dolore magnam ut aspernatur sunt?</p>
                <button>Download Now</button>
            </div>
         </div>
     )
 }

 export default about

 
